import React from 'react'
import { cn } from '@scalis/utils/src'
import {
  customDotClassName,
  defaultDotClassName,
  liClassName,
  timelineLineClassName,
  ulClassName,
} from './timeline.styles'
import { TimelineColor, TimelineOverlayColor, TimelineProps } from './timeline.types'

export const Timeline: React.FC<TimelineProps> = ({
  items,
  className,
  dotClassName,
  color = TimelineColor.BLUE,
  overlayColor = TimelineOverlayColor.BRAND_PRIMARY_LIGHT_00,
}) => {
  return (
    <ul className={cn(ulClassName(), className)}>
      <div className={timelineLineClassName({ color })} />
      {items.map((item, idx) => {
        const isFirst = idx === 0
        const isLast = idx === items.length - 1

        return (
          <li
            key={idx}
            className={cn(
              liClassName({
                overlay: isLast || isFirst,
                overlayColor,
              }),
              item.className,
            )}
          >
            {item.dot ? (
              <div className={cn(customDotClassName(), dotClassName)}>{item.dot}</div>
            ) : (
              <div
                className={cn(defaultDotClassName({ color }), dotClassName)}
                data-testid='default-dot'
              />
            )}

            {item.children}
          </li>
        )
      })}
    </ul>
  )
}
